import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { HomeRoutes } from "./Routes/HomeRoutes";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { StyledEngineProvider } from '@mui/material/styles'; // <<< ADD THIS


// Function to generate a nonce
const generateNonce = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return btoa(String.fromCharCode.apply(null, array));
};

// Generate the nonce
const nonce = generateNonce();

// Get the CSP meta tag and dynamically set it
const metaTag = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
metaTag.setAttribute(
  'content',
  `default-src 'self';
   script-src 'self' 'unsafe-eval' https://www.google-analytics.com 'nonce-${nonce}';
   style-src 'self' 'nonce-${nonce}';
   img-src 'self' data: https://res.cloudinary.com;
   font-src 'self' https://fonts.gstatic.com;
   connect-src 'self' ws://risetomastery.com https://api.risetomastery.com;
   frame-src 'self';
   object-src 'none';
   base-uri 'self';
   form-action 'self';`
);

const cache = createCache({ key: 'css', nonce: nonce });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
        <CacheProvider value={cache}>
          <StyledEngineProvider injectFirst> {/* <<< WRAP WITH THIS */}
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <RouterProvider router={HomeRoutes} />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </ThemeProvider>
          </StyledEngineProvider>
        </CacheProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
